module.exports = __FOREMAN_VENDOR__REDUX__;